module.exports = __webpack_public_path__ + "static/img/icon4.7408dd74.gif";